import * as D from './deps';

const log = D.Logger.child({ component: 'domains/listener/desktopApp/utils' });

export function logBranchError(error) {
  log.error(error, {
    message: 'Not being able to create branch link for desktop app',
  });
  D.DesktopAppUtils.openBranchErrorToast();
}
